import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const SINGLE_LINE_TEXT_FRAGMENT = gqlTagGira`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;
